/* eslint-disable no-alert */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { Component } from 'react'
import { forEach, map, size } from 'lodash'
import moment from 'moment'
import styled from 'styled-components'
import { Segment, Divider, Icon, Button, Header, Form, Modal, TextArea } from 'semantic-ui-react'

import firebase from '../../../config/firebase'

import TimeField from './TimePicker'
import ZoneForm from './ZoneForm'

import utils from '../../../utils'

const FileFieldWrapper = styled.div`
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  border: 1px solid #efefef;
  border-radius: 5px;
  flex-direction: row;
`

const FileUploadWrapper = styled.div`
  flex: 1;
  display: flex;
  height: 50px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border: 1px solid #efefef;
  border-right: 0px;
  ${props => (props.hasFile) && `margin-right: 5px`};
  background-color: ${props => (props.hasFile ? '#fff' : '#efefef')};
`

const FileName = styled.div`
  margin-top: 3px;
  width: 100px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-size: 11px;
  text-align: center;
`

const FileWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
`

const ZoneWrapper = styled.div`
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
`

const STATUS_OPTIONS = [
  { key: 1, text: 'Available', value: 'available' },
  { key: 2, text: 'Blocked', value: 'blocked' },
]

const ACTIVE_OPTIONS = [
  { key: 1, text: 'Active', value: 'active' },
  { key: 2, text: 'Inactive', value: 'inactive' },
]

class ServiceAvailability extends Component {
  btnSubmitRef = React.createRef()

  fileUploadRef = React.createRef()

  state = {
    selectedZones: [{}],
    startTime: Date.now(),
    endTime: Date.now(),
    active: true,
    status: 'blocked',
    file: null,
    customPolygon: null,
    message: {},
    saving: false,
  }

  componentDidMount() {
    const { action, serviceZone } = this.props

    if (action === 'edit') {
      const { active, message, status } = serviceZone
      this.setState({
        active,
        message,
        status,
        startTime: serviceZone.started_at,
        endTime: serviceZone.ended_at,
        file: serviceZone.file_name ? { name: serviceZone.file_name } : null,
        selectedZones: this.getSelectedZones(),
      })
    }
  }

  getSelectedZones = () => {
    const { serviceZone, districts } = this.props

    const zones = []

    forEach(serviceZone.zones, (zone, key) => {
      if (key !== 'polygon') {
        zones.push({
          district: key,
          selectedCommunes: zone.communes,
          allCommunes: districts[key].communes,
        })
      }
    })

    return zones
  }

  validateField = async () => {
    const { selectedZones } = this.state

    const isSelectedZoneEmpty = selectedZones
      .map(zone => !zone.district || zone.selectedCommunes.length === 0)
      .includes(true)

    forEach(selectedZones, zone => {
      const { selectedCommunes, allCommunes } = zone
      const selectedCommunesPolygon = allCommunes.filter(com => selectedCommunes.includes(com.id))

      const isNoPolygonData = selectedCommunesPolygon.map(com => !com.polygon).includes(true)
      if (isNoPolygonData) throw new Error('Some communes have no polygon')
    })

    if (isSelectedZoneEmpty)
      throw new Error('Please select district and communes')

    return true
  }

  onSave = async e => {
    try {
      e.preventDefault()

      const { selectedZones, startTime, endTime, status, active, customPolygon, message, file } = this.state
      const { action, region, serviceZone, setSingleZone, onClose } = this.props

      const collection = firebase.firestore().collection('service_availability')
      const id = action === 'new' ? collection.doc().id : serviceZone.id

      await this.validateField()

      this.setState({ saving: true })

      const zones = {}

      const selectedPolygon = []

      forEach(selectedZones, zone => {
        const { selectedCommunes, allCommunes } = zone
        zones[zone.district] = { communes: selectedCommunes }

        const selectedCommunesPolygon = allCommunes.filter(com => selectedCommunes.includes(com.id))
        const polygon = selectedCommunesPolygon.map(com => JSON.parse(com.polygon))

        selectedPolygon.push(...polygon)
      })

      if (customPolygon && size(customPolygon) > 0) {
        selectedPolygon.push(...customPolygon)
      }

      const data = {
        region,
        started_at: startTime,
        ended_at: endTime,
        polygon: JSON.stringify(selectedPolygon),
        message,
        active,
        status,
        zones,
        id,
        updated_at: Date.now(),
        created_at: serviceZone.created_at || Date.now()
      }

      if (action === 'new') data.created_at = Date.now()

      if (file) {
        data.file_name = file.name
        data.file_polygon = JSON.stringify(selectedPolygon)
      }

      setSingleZone({ data, id })
      await collection.doc(id).set(data)

      this.setState({ saving: false })
      onClose()
    } catch (error) {
      this.setState({ saving: false })
      alert(error.message || error)
    }
  }

  onMessageChange = (field, value) => {
    const { message } = this.state

    this.setState({
      message: {
        ...message,
        [field]: value,
      },
    })
  }

  onZoneChange = (zone, index) => {
    const { selectedZones } = this.state
    const { districts } = this.props
    const zonesArray = Array.from(selectedZones)
    const { district } = zonesArray[Number(index)]

    const allCommunes = districts[zone.district].communes

    let newZone = { ...zone, allCommunes }

    if (size(district) > 0 && zone.district !== district) {
      newZone = { ...newZone, selectedCommunes: [] }
    }
    zonesArray[Number(index)] = newZone

    this.setState({ selectedZones: zonesArray })
  }

  onAddMoreZoneClick = () => {
    const { selectedZones } = this.state
    this.setState({ selectedZones: selectedZones.concat({}) })
  }

  onRemoveClick = index => {
    const { selectedZones } = this.state

    const remainZones = selectedZones.filter((_zone, zoneIndex) => index !== zoneIndex)
    this.setState({ selectedZones: remainZones })
  }

  onFileChange = async e => {
    const file = e.target.files[0]

    if (!file) return

    const data = await utils.helpers.getDataFromJSON(file)

    const polygon = []

    forEach(data.features, d => {
      polygon.push(...d.geometry.coordinates)
    })

    this.setState({ customPolygon: polygon })
    this.setState({ file })
  }

  onResetFile = e => {
    e.target.value = ""
  }

  onTimeChange = (field, value) => {
    const timestamp = value.format("HH:mm")
    this.setState({ [field]: timestamp })
  }

  render() {
    const { startTime, endTime, active, file, selectedZones, message, saving, status } = this.state
    const { visible, loading, onClose, districts, action } = this.props

    return (
      <Modal open={visible} size="small" style={{ marginTop: 0 }}>
        <Header>Add New Service Availability</Header>
        <Modal.Content>
          <Form onSubmit={this.onSave} disabled={loading || saving}>
            <Form.Group widths="equal">
              <Form.Field
                control={TextArea}
                value={message.en}
                label="Message in English"
                onChange={e => this.onMessageChange('en', e.target.value)}
              />
              <Form.Field
                control={TextArea}
                value={message.kh}
                label="Message in Khmer"
                onChange={e => this.onMessageChange('kh', e.target.value)}
              />
            </Form.Group>

            <Form.Group widths="equal">
              <TimeField
                label="Start Time"
                value={moment(startTime, 'h:mm a')}
                onChange={value => this.onTimeChange('startTime', value)}
              />
              <TimeField
                label="End Time"
                value={moment(endTime, 'h:mm a')}
                onChange={value => this.onTimeChange('endTime', value)}
              />
            </Form.Group>

            <Form.Group widths="equal">
              <Form.Select
                required
                search
                fluid
                onChange={(e, data) => this.setState({ status: data.value })}
                label="Status"
                value={status}
                options={STATUS_OPTIONS}
              />
              <Form.Select
                required
                search
                fluid
                onChange={(e, data) => this.setState({ active: data.value === active })}
                label="Active"
                value={active ? 'active' : 'inactive'}
                options={ACTIVE_OPTIONS}
              />
            </Form.Group>

            <Segment color="black" style={{ marginTop: 10 }}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <Header>Zones</Header>
                <div>
                  <Button as="a" icon="add" onClick={this.onAddMoreZoneClick} />
                </div>
              </div>

              <ZoneWrapper className="hide-scrollbar">
                {map(selectedZones, (zone, index) => {
                  return (
                    <React.Fragment key={index}>
                      <ZoneForm
                        action={action}
                        zone={zone}
                        districts={districts}
                        selectedDistricts={selectedZones.map(dis => dis.district)}
                        onChange={zoneData => this.onZoneChange(zoneData, index)}
                        onRemove={() => this.onRemoveClick(index)}
                      />
                      <Divider />
                    </React.Fragment>
                  )
                })}
              </ZoneWrapper>

            </Segment>

            <Form.Group widths="equal" style={{ display: 'flex' }}>
              <Form.Field>
                <label>File Upload</label>
                  <FileFieldWrapper>
                    <FileUploadWrapper onClick={() => this.fileUploadRef.click()} hasFile={Boolean(file)}>
                      {file ? (
                        <FileWrapper>
                          <Icon name="file alternate outline" size="big" color="grey" />
                          <FileName>{file.name}</FileName>
                        </FileWrapper>
                      ) : (
                        <Icon name="upload" size="big" color="grey" />
                      )}
                    </FileUploadWrapper>

                  { file ?
                    <Icon
                      name="close"
                      color="grey"
                      size="big"
                      onClick={() => this.setState({ file: null })}
                    />
                  : null}
                  </FileFieldWrapper>
              </Form.Field>
            </Form.Group>

            <input
              hidden
              accept=".geojson"
              type="file"
              onChange={this.onFileChange}
              onClick={this.onResetFile}
              ref={ref => {
                this.fileUploadRef = ref
              }}
            />

            <button
              type="submit"
              hidden
              ref={ref => {
                this.btnSubmitRef = ref
              }}
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={onClose} disabled={saving}>
            Close
          </Button>
          <Button
            icon
            color="black"
            onClick={() => this.btnSubmitRef.click()}
            loading={saving}
            disabled={saving}
          >
            <Icon name="checkmark" /> Save
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }
}

export default ServiceAvailability



// WEBPACK FOOTER //
// ./src/containers/serviceAvailability/components/ServiceAvailabilityForm.js